import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export enum MenuKeys {
    'POS',
    'KDS'
}

interface MenuContextType {
    selectedMenuKey: MenuKeys;
    setSelectedMenuKey: (key: MenuKeys) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const useMenu = () => {
    const context = useContext(MenuContext);
    if (context === undefined) {
        throw new Error('useMenu must be used within a MenuProvider');
    }
    return context;
};

interface MenuProviderProps {
    children: ReactNode;
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
    const [selectedMenuKey, setSelectedMenuKey] = useState<MenuKeys>(MenuKeys.POS);
    const location = useLocation();

    // Auto-detect menu based on current route
    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith('/pos/kds')) {
            setSelectedMenuKey(MenuKeys.KDS);
        } else if (path.startsWith('/pos')) {
            setSelectedMenuKey(MenuKeys.POS);
        }
    }, [location.pathname]);

    return (
        <MenuContext.Provider value={{ selectedMenuKey, setSelectedMenuKey }}>
            {children}
        </MenuContext.Provider>
    );
};
